import { apiBaseUrl } from 'APIs';
import { socket } from 'app/socket';
import { axios } from './interceptors/request.interceptor';

import { CreateNftBid, NftBid } from 'interfaces/NftBid.interface';
import NftData, { INftForm } from 'interfaces/NftData.interface';
import { IOtrForm, OtrData } from 'interfaces/OtrData.interface';
import { IpfsFileUploadData } from 'interfaces/IpfsFileUploadData.interface';

export const getAllNfts = async () => {
  const url = `${apiBaseUrl}nft/`;
  return await axios.get<NftData[]>(url);
};

export const getAllOtrs = async () => {
  const url = `${apiBaseUrl}otr/`;
  return await axios.get<OtrData[]>(url);
};

export const getNft = async (id: string) => {
  const url = `${apiBaseUrl}nft/${id}`;
  return await axios.get<NftData>(url);
};

export const createNft = async (data: INftForm) => {
  const url = `${apiBaseUrl}nft/create`;
  return await axios.post<NftData>(url, {
    ...data,
    reservedBid: +data.reservedBid,
  });
};

export const searchedNfts = async (query: string) => {
  const url = `${apiBaseUrl}nft/search/nfts?query=${query}`;
  return await axios.get(url);
};

export const updateNft = async (data: Partial<NftData>) => {
  const url = `${apiBaseUrl}nft/update`;
  console.log('data', data);
  return await axios.patch<NftData>(url, data);
};

export const increaseNftView = async (id: number) => {
  const url = `${apiBaseUrl}nft/viewed`;
  return await axios.patch<NftData>(url, { id });
};

export const getUsersNfts = async (username: string) => {
  const url = `${apiBaseUrl}nft/user/${username}`;
  return await axios.get<NftData[]>(url);
};

export const findNftBids = async (id: number) => {
  const url = `${apiBaseUrl}nft-bid/find-bids/${id}`;
  return await axios.get<NftBid[]>(url);
};

export const createNftBid = async (data: CreateNftBid) => {
  const url = `${apiBaseUrl}nft-bid/create`;
  const res = await axios.post<NftBid>(url, data);
  if (res.status === 201) {
    socket.emit('bidCreated', res.data);
  }
  return res;
};

export const getNftBids = async (nftId: number) => {
  const url = `${apiBaseUrl}nft-bid/${nftId}`;
  return await axios.get<NftBid[]>(url);
};

export const getNfts = async () => {
  const url = `${apiBaseUrl}nft/auction/all`;
  return await axios.get(url);
};

export const getNftsForHome = async () => {
  const url = `${apiBaseUrl}nft/auction/ended`;
  return await axios.get(url);
};

export const createOtr = async (data: IOtrForm) => {
  const url = `${apiBaseUrl}otr`;
  return await axios.post(url, {
    ...data,
  });
};

export const updateOtr = async (data: Partial<OtrData>) => {
  const url = `${apiBaseUrl}otr/update`;
  return await axios.patch<OtrData>(url, data);
};

export const increaseOtrView = async (id: number) => {
  const url = `${apiBaseUrl}otr/viewed`;
  return await axios.patch<OtrData>(url, { id });
};

export const uploadIpfsFile = async (data: FormData) => {
  const url = `${apiBaseUrl}file-upload/ipfs`;
  const headers = {
    'Content-Type': 'multipart/form-data',
  };
  return await axios.post<IpfsFileUploadData>(url, data, { headers });
};

export const uploadFileWatermark = async (data: FormData) => {
  const url = `${apiBaseUrl}file-upload/video-watermark`;
  const headers = {
    'Content-Type': 'multipart/form-data',
  };
  return await axios.post(url, data, { headers });
};
